import React from "react"
import { defineMessages } from "react-intl"
import PropTypes from "prop-types"
import Tree from "./tree/Tree"
import Table from "./table/Table"
import LazyChart from "./LazyChart"
import TextArea from "./TextArea"
import AlertByLevel from "../AlertByLevel"
import useSmartFormat from "../../i18n/useSmartFormat"

const TableHiddenHeaderOverrideWidgetIds = [
  "Presentation_SRI",
  "Presentation_SRRI",
  "Presentation_pInformations12",
  "Presentation_pInformations22"
]

const messages = defineMessages({
  noData: {
    defaultMessage: "No data available",
    id: "widget.dashboard.nodata"
  }
})

// ## //
function NoData() {
  const format = useSmartFormat()
  const message = [{ info: format(messages.noData) }]
  return <AlertByLevel message={message} />
}

export default function WidgetElement(props) {
  const { data, children, title, widgetId, advancedOptions, ...rest } = props

  if (data.type === "tree") {
    return (
      <Tree title={title} data={data}>
        {children}
      </Tree>
    )
  }
  if (data.type === "grid") {
    const { TableProps } = rest
    // eslint-disable-next-line react/destructuring-assignment
    if (TableHiddenHeaderOverrideWidgetIds.includes(props.widgetId)) {
      data.data.hideHeaders = true
      delete data.title
    }

    return (
      <Table TableProps={TableProps} title={title} data={data}>
        {children}
      </Table>
    )
  }
  if (data.type === "chart") {
    const { ChartContainerProps, ChartProps } = rest

    if (
      data.data &&
      data.data[0] &&
      data.data[0].series &&
      data.data[0].series.length === 0
    ) {
      if (ChartProps?.onEmpty) {
        return ChartProps.onEmpty()
      }
      return <NoData />
    }

    return (
      <LazyChart
        data={data}
        title={title}
        ChartContainerProps={ChartContainerProps}
        ChartProps={ChartProps}
        advancedOptions={advancedOptions}
        widgetId={widgetId}
      />
    )
  }
  if (data.type === "text") {
    const { TextProps } = rest
    if (data.data.value === "") {
      const { onEmpty } = TextProps || { onEmpty: NoData }
      if (!onEmpty) {
        return null
      }

      return onEmpty()
    }

    return (
      <TextArea
        data={data.data.value}
        advancedOptions={advancedOptions}
        title={title}
        TextProps={TextProps}
      />
    )
  }
  return <div>{data.data}</div>
}

WidgetElement.propTypes = {
  data: PropTypes.object,
  advancedOptions: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  widgetId: PropTypes.string.isRequired,
  params: PropTypes.object,
  subscriptions: PropTypes.object,
  transformer: PropTypes.string,
  reqOpt: PropTypes.shape({
    endpoint: PropTypes.string,
    bodyOpt: PropTypes.object
  })
}

WidgetElement.defaultProps = {
  data: undefined,
  advancedOptions: {},
  title: "",
  params: undefined,
  children: undefined,
  subscriptions: undefined,
  transformer: undefined,
  reqOpt: undefined
}
